export default __webpack_public_path__ + "static/media/newyear10.ac1b076d.png";